export enum TemperatureType {
  RADIATOR = 'radiator',
  VRV = 'vrv',
  FAN_COIL = 'fanCoil',
  HEATED_FLOOR = 'heatedFloor',
  MODE_MONITORING = 'modeMonitoring',
}
